import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import BenefitsBar from "./components/BenefitsBar";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import ProcessSection from "./components/ProcessSection";
import TrustSection from "./components/TrustSection";
import FaqSection from "./components/FaqSection";
import AnalyzerCTA from "./components/AnalyzerCTA";
import ContactSection from "./components/ContactSection";
import LocalAreaSection from "./components/LocalAreaSection";
import ToolsSection from "./components/ToolsSection";
import JsonLD from "@/components/base/JsonLD";
import { homeSchema, webSiteSchema } from "@/components/base/PageSchemas";
import BlogSection from "./components/BlogSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLD data={homeSchema} />
      <JsonLD data={webSiteSchema} />
      <Navbar />

      <main>
        <HeroSection />
        <BenefitsBar />
        <ToolsSection />
        <BlogSection />
        <AboutSection />
        <ServicesSection />
        <ProcessSection />
        <TrustSection />
        <FaqSection />
        <AnalyzerCTA />
        <LocalAreaSection />
        <ContactSection />
      </main>

      <Footer />
    </div>
  );
}
